import React, { render, Component } from 'preact';
import http from './http';
import collage from  './img/collage.jpg'


export default class OfferBody extends Component {

    constructor(props) {
        super(props);

        this.state = {};
        this.state.body = {};
        this.state.offers = [];
        if (window.details) {
            this.state.body = window.details;
            this.state.offers = window.details.Offers;
        }


    }


    checkState() {
        var checkstate = "/check/" + this.state.body.ID;
        http.get(checkstate).then((response) => {
            console.log(response);
            try {
                response = JSON.parse(response);
            } catch (error) {
                console.log(error)
            }

            if (Array.isArray(response)) {
                this.setState({ "offers": response });
            }


            console.log(response);


        })

    }

    componentDidMount() {
        this.interval = setInterval(() => { this.checkState() }, 15000);
    
   
    

    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    generateOffer(offerID, offerURL) {

        var index = this.state.offers.findIndex((element, index, array) => { return element.ID == offerID });

        var offer = this.state.offers[index];
        offer.State = 3;

        var offers = [...this.state.offers];
        offers[index] = offer;
        this.setState({ offers: offers });

        http.get(offerURL).then((response) => {
            try {
                console.log(response);
                response = JSON.parse(response);
                console.log(response);
                if (response.state == 0) {
                    window.location.href = "https://payments.royalcaribbeanbelize.com/flashdeal/" + response.url;
                } else {
                    window.location.reload(true);
                }
            } catch (error) {
                console.log(error)
            }


        })

    }

    showImages(){
        var pswpElement = document.querySelectorAll('.pswp')[0];

        console.log(window.PhotoSwipe)
           // build items array
           var items = [
               {
                   src: 'https://flashdeals.royalcaribbeanbelize.com/img/room1.jpg',
                   w: 1152,
                   h: 768
               },
               {
                   src: 'https://flashdeals.royalcaribbeanbelize.com/img/room2.jpg',
                   w: 1527,
                   h: 1080
               },
               {
                   src: 'https://flashdeals.royalcaribbeanbelize.com/img/pool.jpg',
                   w: 1152,
                   h: 768
               },
               {
                   src: 'https://flashdeals.royalcaribbeanbelize.com/img/night.jpg',
                   w: 1152,
                   h: 768
               },
               {
                   src: 'https://flashdeals.royalcaribbeanbelize.com/img/night2.jpg',
                   w: 1152,
                   h: 768
               }
           ];
   
   
           var options = {
               // optionName: 'option value'
               // for example:
               index: 0 // start at first slide
           };
           
           var gallery = new window.PhotoSwipe( pswpElement, window.PhotoSwipeUI_Default, items, options);
           gallery.init();
    }


    render() {
        return (
            <div>

                <div class="pswp" tabindex="-1" role="dialog" aria-hidden="true">


                    <div class="pswp__bg"></div>


                    <div class="pswp__scroll-wrap">


                        <div class="pswp__container">
                            <div class="pswp__item"></div>
                            <div class="pswp__item"></div>
                            <div class="pswp__item"></div>
                        </div>

                        <div class="pswp__ui pswp__ui--hidden">

                            <div class="pswp__top-bar">


                                <div class="pswp__counter"></div>

                                <button class="pswp__button pswp__button--close" title="Close (Esc)"></button>

                                <button class="pswp__button pswp__button--share" title="Share"></button>

                                <button class="pswp__button pswp__button--fs" title="Toggle fullscreen"></button>

                                <button class="pswp__button pswp__button--zoom" title="Zoom in/out"></button>


                                <div class="pswp__preloader">
                                    <div class="pswp__preloader__icn">
                                        <div class="pswp__preloader__cut">
                                            <div class="pswp__preloader__donut"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="pswp__share-modal pswp__share-modal--hidden pswp__single-tap">
                                <div class="pswp__share-tooltip"></div>
                            </div>

                            <button class="pswp__button pswp__button--arrow--left" title="Previous (arrow left)">
                            </button>

                            <button class="pswp__button pswp__button--arrow--right" title="Next (arrow right)">
                            </button>

                            <div class="pswp__caption">
                                <div class="pswp__caption__center"></div>
                            </div>

                        </div>

                    </div>

                </div>
                <div id="offer-title">
                    <div id="offer-title-info">
                        <div className="offer-title-text offer-title-price">
                            <span> ${this.state.body.Price} <span className="old-price-offer">${this.state.body.OldPrice}</span> Per Night</span>
                        </div>
                        <div className="offer-title-text">
                            <div>
                                <div className="offer-body-date">
                                    <div className="offer-body-date-year">{this.state.body.ArrivalYear}</div>
                                    <div>{this.state.body.Arrival}</div>
                                </div> <div className="offer-arrow">&rarr;</div> <div className="offer-body-date">
                                    <div className="offer-body-date-year">{this.state.body.DepartureYear}</div>
                                    <div>{this.state.body.Departure}</div>
                                </div>
                            </div>
                            <div>{this.state.body.NightCount} nights</div>
                        </div>
                    </div>
                    <div id="offer-image-holder"><img id="offer-image" /></div>
                </div>
                <div className="full-offer-details">
                    <div className="offer-details-text">
                        <div className="offer-details-title">What do you get?</div>
                        <div className="offer-details-description" dangerouslySetInnerHTML={{ __html: this.state.body.Description }} />
                         <div id="image-collage" onClick={this.showImages}><img src={collage} /></div>
                        <div className="offer-details-fineprint-title">The Fine Print</div>
                        <div className="offer-details-description" dangerouslySetInnerHTML={{ __html: this.state.body.fineprint }} />
                    </div>
                    <div id="offers-holder">
                        <div id="offers-title">Current Offers</div>
                        <div className="offer-list">

                            {
                                this.state.offers.map((offer) => {
                                    var state = parseInt(offer.State, 10)

                                    if (state === 0) {
                                        return (
                                            <div key={offer.ID} onClick={() => { this.generateOffer(offer.ID, `/gen/${this.state.body.ID}/${offer.ID}`) }} className="offer-detail-info offer-available" >
                                                <div className="offer-available-text urgent">Available</div>
                                                <div>Click to Pay</div>
                                            </div>)
                                    } else if (state === 1) {
                                        return (
                                            <div key={offer.ID} className="offer-detail-info offer-being-viewed">
                                                <div>Being Viewed</div>
                                            </div>)
                                    } else if (state === 2) {
                                        return (
                                            <div key={offer.ID} className="offer-detail-info offer-unavailable">
                                                <div>Taken</div>
                                            </div>)
                                    }
                                    else if (state === 3) {
                                        return (
                                            <div key={offer.ID} className="offer-detail-info offer-checking">
                                                <div>Checking</div>
                                            </div>)
                                    }
                                })
                            }
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}